import { createAction, handleActions } from "redux-actions";

const SET_LOADING = "saga/SET_LOADING";
const UPDATE_PROGRESS = "saga/UPDATE_PROGRESS";
const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";

export const actionCreators = {
  setLoading: createAction(SET_LOADING),
  updateProgress: createAction(UPDATE_PROGRESS),

  fetchTableDataSuccess: createAction(FETCH_TABLE_DATA_SUCCESS)
};

export const initialState = {
  currentUser: {},
  tableInfo: {},
  labelInfo: "",
  headerInfo: [],
  isLoading: false,
  dataPoints: [],
  progress: {}
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload || state.isLoading
    }),
    [UPDATE_PROGRESS]: (state, action) => ({
      ...state,
      progress: action.payload || {}
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload.currentUser || state.currentUser,
      tableInfo: action.payload.tableInfo || state.tableInfo,
      labelInfo: action.payload.labelInfo || state.labelInfo,
      headerInfo: action.payload.headerInfo || state.headerInfo,
      dataPoints: action.payload.endpoints || state.dataPoints,
      isLoading: false
    })
  },
  initialState
);
